export const SMS_CONSENT_AUTOMATED_MESSAGE = 'SMS_CONSENT_AUTOMATED_MESSAGE';